



















































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { UsersRepository } from '@/repository/UsersRepository';
import { NotificationSettingModel } from '@/store/types';
import { Authentication, checkAuthentication } from '@/components/Authentication';

@Component({
  beforeRouteEnter(to, from, next) {
    checkAuthentication(next);
  },
  beforeRouteUpdate(to, from, next) {
    checkAuthentication(next);
  },
})
export default class Settings extends Vue {
  private notificationSetting = new NotificationSettingModel();

  private async mounted() {
    const selfInfo = await UsersRepository.getSelfInfo();
    this.notificationSetting = selfInfo.data.notification as NotificationSettingModel;
  }

  private async setNotificationSetting() {
    await UsersRepository.setNotificationSetting(this.notificationSetting);
  }
}
